import { render, staticRenderFns } from "./PokemonPorHabilidad.vue?vue&type=template&id=7b54a5b4&"
import script from "./PokemonPorHabilidad.vue?vue&type=script&lang=js&"
export * from "./PokemonPorHabilidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports